import useResources from "./use-resources";

const ROOT_PATH = "mandat-prelevement-fichier";

export default function useMandatPrelevementFichier() {
  const {
    resources: mandatPrelevementFichiers,
    error,
    isLoading,
    create,
    update,
    del,
    axios,
  } = useResources(ROOT_PATH);

  async function getBordereauUrl(fichierId) {
    const response = await axios.get(`${ROOT_PATH}/${fichierId}/bordereau`);
    return response.data;
  }

  return {
    mandatPrelevementFichiers,
    error,
    isLoading,
    createMandatPrelevementFichier: create,
    updateMandatPrelevementFichier: update,
    deleteMandatPrelevementFichier: del,
    getBordereauUrl,
  };
}
